import { createSelector } from 'reselect';
import get from 'lodash/get';

import { CONSTANTS } from 'enum';
import { ERRORS, CONTRACT_ID_ERROR } from './propertiesNames';

export const paymentErrorsSelector = (state) => get(state, [CONSTANTS.PAYMENT, ERRORS]);

export const contractIdErrorSelector = createSelector(paymentErrorsSelector, (errors) => errors[CONTRACT_ID_ERROR]);
